import httpService from "./HttpService";

export async function getCalender(companyId, fromDate, toDate) {
  const token = localStorage.getItem("auth");
  return httpService.get(`calender/${companyId}/${fromDate}/${toDate}`, null, token);
}

export async function createOneTimeCalendarEntry(scheduleData) {
  const token = localStorage.getItem("auth");
  return httpService.post(`calender/one-time`, scheduleData, token);
};

export async function deleteOneTimeCalendarEntry(calendarId){
  const token = localStorage.getItem("auth");
  return httpService.delete(`calender/one-time/${calendarId}`, null, token);
};
